import {Center, Wrap, WrapItem, Button, Text, VStack} from "@chakra-ui/react";
import {openHome, openJoin, openDownload, openSupport, openTerms, openPrivacy, openCookies, openHowToPlay} from "./links";

export function AppFooter() {
    return (
        <Center
            backgroundColor="red"
            padding="24px"
            paddingTop="48px"
            paddingBottom="48px"
        >
            <VStack
                spacing="24px"
            >
                <Wrap
                    spacing="32px"
                    justify="center"
                >
                    <WrapItem>
                        <Button
                            variant="link"
                            color="white"
                            onClick={openHome}
                        >
                            Home
                        </Button>
                    </WrapItem>
                    <WrapItem>
                        <Button
                            variant="link"
                            color="white"
                            onClick={openJoin}
                        >
                            Play online
                        </Button>
                    </WrapItem>
                    <WrapItem>
                        <Button
                            variant="link"
                            color="white"
                            onClick={openDownload}
                        >
                            Download
                        </Button>
                    </WrapItem>
                    <WrapItem>
                        <Button
                            variant="link"
                            color="white"
                            onClick={openHowToPlay}
                        >
                            How to play
                        </Button>
                    </WrapItem>
                    <WrapItem>
                        <Button
                            variant="link"
                            color="white"
                            onClick={openSupport}
                        >
                            Support
                        </Button>
                    </WrapItem>
                    <WrapItem>
                        <Button
                            variant="link"
                            color="white"
                            onClick={openTerms}
                        >
                            Terms and conditions
                        </Button>
                    </WrapItem>
                    <WrapItem>
                        <Button
                            variant="link"
                            color="white"
                            onClick={openPrivacy}
                        >
                            Privacy
                        </Button>
                    </WrapItem>
                    <WrapItem>
                        <Button
                            variant="link"
                            color="white"
                            onClick={openCookies}
                        >
                            Cookies
                        </Button>
                    </WrapItem>
                </Wrap>
                <Text
                    color="white"
                    align="center"
                >
                    iPadOS, macOS and Apple TV are registered trademarks of Apple Inc., registered in the US and other countries.
                </Text>
                <Text
                    color="white"
                    align="center"
                >
                    Copyright (c) 2021 Benjamin Robinson. All Rights Reserved.
                </Text>
            </VStack>
        </Center>
    );
}